var RedactionNoteModel = require('../redaction'),
    FullPageRedactionNoteView = require('../../../../../../../views/note/redaction/fullPageRedaction'),
    FullPageRedactionShapeView = require('../../../../../../../../canvas/views/shape/redaction/fullPageRedaction/fullPageRedactionShape'),
    FullPageRedactionShapeModel =  require('../../../../../../../../canvas/models/coordinate/redaction/fullPageRedaction/shapeModel'),
    ShapeUtils = require('../../../../../../../../canvas/models/shapeUtils');


/**
 * this.isConvertingToFloatingCodes should always be false.
 * init: won't be saved using this -- it's type 'E' -- use to style the same as type D redactions.
 * This notetype is now the only one we are parsing the shapes models with the note model.
 * Note: on subsequent parse we now aren't deleting the existing shape models -- as that's causing issues --
 * see inline comments.
 */


module.exports = RedactionNoteModel.extend({

    SUPPORTS_FIND_AND_REDACT: false,

    ViewConstructor: FullPageRedactionNoteView,
    desc: 'Full Page Redaction',
    actionTitle: 'Full Page Redaction',
    iconClass: 'icon-resize-full-alt-1',//'icon-doc-inv',
    createHotKey: 'f',
    init: 'E',
    subTypes: ['rect'], // TODO: not necessary and these aren't used in the app anymore

    parse: function(response, options) {

        var resp = RedactionNoteModel.prototype.parse.apply( this, arguments );

        // create shapes if new -- can't use isNew yet b/c haven't gone through constructor process
        // sequence will indicate if the note is new/not
        if ( !resp.sequence ) {

            // here we create one shape model for the shapes array -- there can only be one for this note type
            // we can preset the points first b/c its the dimensions of the page
            var ShapeModel = this.getShapeModel();
            var pageModel = options.pageModel;

            // Note: last reason codes not set for this noteType b/c of flag on shapeModel,
            // and also because this shape type is NEVER 'newlyDrawn'.
            var shape = new ShapeModel(
                {
                    points: ShapeUtils.getPointsToSaveFromPageDimensions(pageModel) // ( pixels --> 1/10 mm)
                },
                {
                    // TODO: should be using ID's everywhere; too many references; eg the page has a notesCollection ...
                    parentNote: this,
                    pageModel: pageModel,
                    shapeIndexOfNote: 0 // should only be one

                }
            );

            this.shapes.push( shape );

        } else {


            // If employ for other shape types we may want to destroy any remaining on parse ( a reset ).
            // But without larger changes now this is problematic: on activeNoteChange (eg edit),
            // You'd need reset the shape collection ... and/or tie the model from the note to the canvas.
            // But now its creating errors -- eg raphaelEl is not set after save; you'd need alter canvas/note
            // Workflow so that canvas is always rendered with the updated shapes, set after parse.
            /*
             if ( this.shapes.length > 0) {

                 _.each( this.shapes, function( shape, i ) {
                 shape.destroy();
                 }, this);

                 this.shapes = null;
                 this.shapes = [];
             }
             */

            var pageId = resp.pageId,
                pageModel = options.pageCollection.findWhere({ pageId: pageId });

            this.createShapesFromModelAttributes( resp.shapes, pageModel );

        }

        return resp;

    },

    // Called on parse or on reset
    // Shapes are the attributes from the model
    // Could share logic with getShapeModelsToRender from other notetypes
    createShapesFromModelAttributes: function( shapes, pageModel ) {

        var ShapeModel = this.getShapeModel();

        this.shapes = _.map( shapes, function( shape, i ) {

            return new ShapeModel( shape, {
                parentNote: this,
                pageModel: pageModel,
                shapeIndexOfNote: i // ( should only be 1 )
            });

        }, this);


    },


    // Utilize existing reset function to reset the shapes array when the user cancels changes.
    // ( from its current state to what was sent from the server -- what exists in the attributes )
    // Can make this generic is employ a generic parse for other shape/note types
    resetOnCancelChanges: function() {

        RedactionNoteModel.prototype.resetOnCancelChanges.apply( this, arguments );

        // Store pageModel for upcoming 'parse' prior to destruction
        var pageModel = this.shapes[0].pageModel;

        // Reset: now not doing and not sure if needed -- there are listeners (like with above on parse)
        // Destroying causes issues.
        // All the other views on the canvas should be removed in subsequent call anyway.

        //_.each( this.shapes, function(shape) {
            //shape.destroy(); -- destroy here has listeners ...
            //shape = null;
        //});

        //this.shapes = null;

        this.createShapesFromModelAttributes( this.get('shapes'), pageModel );

    },


    // This is also called from the canvas -- here we want to return the shapes we stored already
    // May want to make this more generic is expand to other note types
    shapeModelsToRender: function() {

        return this.shapes;

    },

    // Convenience given only ever one shape
    getShape: function() {
        return this.shapes[0];
    },

    shapeView: function(options) {
       return new FullPageRedactionShapeView(options);
    },

    getShapeModel: function() {
        return FullPageRedactionShapeModel;
    },

    // Don't apply any stroke-width -- its the size of the page
    defaultSVGAttrsEdit: function() {

        var attrs = RedactionNoteModel.prototype.defaultSVGAttrsEdit.apply( this, arguments );
        attrs['stroke-width'] = 0;
        return attrs;

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/coordinate/redaction/fullPageRedaction/model.js
 ** module id = 311
 ** module chunks = 0
 **/